import React from "react";
import { Link } from "react-router-dom";

function DownloadBasic({ files, fileName, preview, color, Textcolor, BtIColor, Iconcolor }) {

  const { file1, file2, file3, file4 } = files;
  const HColor = color ? color : 'black'


  return (
    <div>

      {fileName?.fileName1 ? (
        <Link
          to={`${preview ? file1 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >

          <div className="flex gap-3   items-center     p-4 m-2 rounded-[8px] justify-between" >
            <div className="flex justicy-start items-center gap-[20px]">
              <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linejoin="round" />
              </svg>


              <p className="text-[12px] font-medium text-left my-2" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>
                {fileName?.fileName1 ? fileName.fileName1 : "File Name"}
              </p>

            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66699 2V8.39067L11.0003 6.05733L11.943 7L8.00033 10.9427L4.05766 7L5.00033 6.05733L7.33366 8.39067V2H8.66699ZM3.00033 9.33333V12.6667H13.0003V9.33333H14.3337V14H1.66699V9.33333H3.00033Z" fill={BtIColor ? BtIColor : "#888888"} />
            </svg>

          </div>

        </Link>
      ) : (
        ""
      )}
      {fileName?.fileName2 ? (
        <Link
          to={`${preview ? file2 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="flex justicy-start items-center gap-[20px]">
            <div className="flex justicy-center items-center gap-[20px] mt-2">
              <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linejoin="round" />
              </svg>

              <p className="text-[12px] font-medium text-left my-2" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>
                {fileName?.fileName2 ? fileName.fileName2 : "File Name"}
              </p>
            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66699 2V8.39067L11.0003 6.05733L11.943 7L8.00033 10.9427L4.05766 7L5.00033 6.05733L7.33366 8.39067V2H8.66699ZM3.00033 9.33333V12.6667H13.0003V9.33333H14.3337V14H1.66699V9.33333H3.00033Z" fill={BtIColor ? BtIColor : "#888888"} />
            </svg>

          </div>
        </Link>
      ) : (
        ""
      )}
      {fileName?.fileName3 ? (
        <Link
          to={`${preview ? file3 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="flex justicy-start items-center gap-[20px]">
            <div className="flex justicy-center items-center gap-[20px] mt-2">
              <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linejoin="round" />
              </svg>

              <p className="text-[12px] font-medium text-left my-2" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>
                {fileName?.fileName3 ? fileName.fileName3 : "File Name"}
              </p>
            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66699 2V8.39067L11.0003 6.05733L11.943 7L8.00033 10.9427L4.05766 7L5.00033 6.05733L7.33366 8.39067V2H8.66699ZM3.00033 9.33333V12.6667H13.0003V9.33333H14.3337V14H1.66699V9.33333H3.00033Z" fill={BtIColor ? BtIColor : "#888888"} />
            </svg>

          </div>
        </Link>
      ) : (
        ""
      )}
      {fileName?.fileName4 ? (
        <Link
          to={`${preview ? file4 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="flex justicy-start items-center gap-[20px]">
            <div className="flex justicy-center items-center gap-[20px] mt-2">
              <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.875" stroke-linejoin="round" />
              </svg>

              <p className="text-[12px] font-medium text-left my-2" style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>
                {fileName?.fileName4 ? fileName.fileName4 : "File Name"}
              </p>
            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66699 2V8.39067L11.0003 6.05733L11.943 7L8.00033 10.9427L4.05766 7L5.00033 6.05733L7.33366 8.39067V2H8.66699ZM3.00033 9.33333V12.6667H13.0003V9.33333H14.3337V14H1.66699V9.33333H3.00033Z" fill={BtIColor ? BtIColor : "#888888"} />
            </svg>

          </div>
        </Link>
      ) : (
        ""
      )}
    </div>
  );
}

export default DownloadBasic;